module.exports = __webpack_public_path__ + "img/1.ac742d50.jpg";